import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/menu-digital/zona-gamer-personalizada/ZonaGamerClient.tsx");
